








import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class SingleText extends Vue {
    @Prop() value?: string;
}
